module.exports = __webpack_public_path__ + "img/114ne.c8ef5efa.svg";